<template>
    <transition name="fade">
        <div class="number-user-online mt-4 mb-2 fs-md text-gray" v-if="!hidden && wrapper">
            {{ displayMessage }}
        </div>
      <span v-else-if="!hidden">
        {{ displayMessage }}
      </span>
    </transition>
</template>

<script>
import utils from '../../../lib/utils.js';

export default {
    name: "NowBuying",
    data () {
        return {
            hidden: true,
            tid: null
        }
    },
    props: {
      wrapper: {
        type: Boolean,
        default: true
      },
      count: {
        type: Number,
        default: 0
      },
      timeFromShow: {
            type: Number,
            default: 0
        }
    },
    computed: {
        displayMessage () {
            if (this.count > 0) {
                return utils.declOfNum(this.count, [
                    `Сейчас ${this.count} человек выбирает номера`,
                    `Сейчас ${this.count} человека выбирают номера`,
                    `Сейчас ${this.count} человек выбирают номера`
                ], false);
            }
            return null;
        }
    },
    beforeDestroy() {
        clearTimeout(this.tid)
    },
    mounted () {
        this.show()
    },
    methods: {
        show () {
            if (this.count <= 0) {
                return
            }
            if (this.timeFromShow > 0) {
                this.tid = setTimeout(() => {
                    this.hidden = false
                }, this.timeFromShow * 1000)
            } else {
                this.hidden = false
            }
        }
    }
}
</script>

<style lang="scss">
@import '../../../scss/transition/fade.scss';

.number-user-online {
    background: url('/static_files_new/img/design/stopwatch.svg') no-repeat left top;
    font-size: 14px;
    color: #777;
    width: 190px;
    padding-left: 35px;
    margin-left: 15px;
    margin-bottom: 40px;
}
</style>